
// Options

var rowLimit = 100;


// Require

var TableRow = require('../modules/table-row');


// Helper functions

var TIMING_ENABLED = true;

function time (name) {
  if (TIMING_ENABLED) console.time(name);
  return name;
}

function stop (name) {
  if (TIMING_ENABLED) console.timeEnd(name);
}


// Sorting functions

function alphaSort (field) {
  return function (a, b) {
    var ax = a.sortKey(field).toUpperCase(), bx = b.sortKey(field).toUpperCase();
    return ax === bx ? 0 : ax < bx ? -1 : 1;
  }
}

function numSort (field) {
  return function (a, b) {
    var ax = parseInt(a.sortKey(field), 10), bx = parseInt(b.sortKey(field), 10);
    return ax - bx;
  }
}

function dateSort (field) {
  return function (a, b) {
    log(a.sortKey(field), b.sortKey(field));
  }
}

function statusSort (field) {
  var statuses = [ 'valid', 'expired', 'redeemed', 'void' ];
  return function (a, b) {
    return statuses.indexOf(a.sortKey(field)) - statuses.indexOf(b.sortKey(field));
  }
}

function comboSort (field) {
  return function (a, b) {
    var ax = parseInt(a.sortKey(field).replace(/[^\d]/g, ''), 10);
    var bx = parseInt(b.sortKey(field).replace(/[^\d]/g, ''), 10);

    if (isNaN(ax) && isNaN(bx)) return alphaSort(field)(a, b);
    if (isNaN(ax)) return 1;
    if (isNaN(bx)) return -1;
    return ax - bx;
  }
}


//
// Filter Table
//

module.exports = function FilterTableWidget ($host, config) {

  time('FilterTable::init');

  // Read data as json
  var data = safeJsonParse($('[data-table-data]', $host).text());

  // Dom
  var dom = {
    main:    $host,
    parent:  $('[data-table-row-host]').parent(),
    rowHost: $('[data-table-row-host]'),
  };

  // State
  var callbacks = { exact: id };
  var rows = data.data.map(newTableRow(data.headers, data.filter_keys.split(','), data.link_base));
  var lastQuery = '';


  // Functions

  function newTableRow (headers, filterKeys, linkBase) {
    return function (rowData, ix) {
      // Reconstitute object stucture from seperated header
      var voucher = zip(headers, rowData);

      // Reconstitute filter keywords from list of keys
      voucher.filter_keywords = filterKeys.map(function (key) { return voucher[key]; });

      // Reconstitute implicit link destination from code and provided base url
      // TEMP: Include voucher id for disambiguation
      voucher.link = linkBase + voucher.voucher_code + '/' + voucher.voucher_id;

      // Output sample of reconstructed voucher data
      // if (ix === 0) log("Sample voucher:", JSON.stringify(voucher, null, 2) );

      // Return as instantiated table row
      return TableRow(voucher);
    }
  }

  function logRows (field) {
    log(rows.map(function (row) { return row.sortKey(field); }).join("\n"));
  }

  function sort (field, reverse) {
    var type = (reverse ? 'reverse-' : '') + rows[0].sortType(field) + '-sort';
    var t = time('sorted by ' + field + ' (' + type + ') on ' + rows.length + ' rows');

    switch (rows[0].sortType(field)) {
      case 'num':    rows.sort(numSort(field));    break;
      case 'date':   rows.sort(alphaSort(field));  break;
      case 'combo':  rows.sort(comboSort(field));  break;
      case 'alpha':  rows.sort(alphaSort(field));  break;
      case 'status': rows.sort(statusSort(field)); break;
      default: console.warn('FilterTale::sort - unsupported sort type:', rows[0].sortType(field));
    }

    if (reverse) rows.reverse();

    stop(t);
  }

  function filter (query) {
    var t = time('filtered ' + rows.length + ' rows');
    var q = query.toLowerCase();
    var blankQuery = q === '';
    var exactMatches = [];

    for (var i = 0, m = rows.length; i < m; i++) {
      var row = rows[i];
      row.ok = blankQuery ? !row.data.hide_from_default_overview : row.keywordMatch(q);
      if (row.exactMatch(query)) { exactMatches.push(row); }
    }

    if (exactMatches.length === 1) callbacks.exact(exactMatches[0]);

    lastQuery = query;
    stop(t);
  }

  function sortByKey (field, reverse) {
    sort(field, reverse);
    filter(lastQuery);
    updateDom();
  }

  function updateDom () {
    var t = time('Updating table dom');
    var r = 0;

    dom.rowHost.remove().html('');

    for (var i = 0, m = rows.length; i < m; i++) {
      var row = rows[i];
      if (row.ok) { r += 1; row.appendTo(dom.rowHost); }
      if (r >= rowLimit) break;
    }

    dom.parent.append(dom.rowHost);
    stop(t);
    log('Table updated:', r, (r === 1 ? 'row' : 'rows'));
  }


  // Listeners - patch mock-up redeem button into exact-match modal trigger

  $host.on('click', 'button[data-redeem-code]', function (event) {
    var vid  = this.dataset.redeemVid;
    var code = this.dataset.redeemCode;
    var selection = rows.filter(function (row) { return row.exactMatch(code) && row.data.voucher_id === vid; });
    log('FilterTable::onRedeemButton -', code + '[' + vid + ']');
    if (selection.length) callbacks.exact(selection[0]);
  });


  // Interface

  return {
    filter: function (q) { filter(q); updateDom(); },
    sortByKey: sortByKey,
    onExactMatch: function (λ) { callbacks.exact = λ; },
  }

}

